export const GET_SHOW_REQUEST = 'GET_SHOW_REQUEST';
export const GET_SHOW_SUCCESS = 'GET_SHOW_SUCCESS';
export const GET_SHOW_ERROR = 'GET_SHOW_ERROR';



// WEBPACK FOOTER //
// ./src/store/show/showActionTypes.js